import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATklEQVR42l2NSwrAIBQDvf8tu3FXS2tR3zdVRIQGkkUYmIAVd5gKftEwVqiCyo18HqCawa1AhTcwjpovvCl2KKI8CcJtA9NgcNPZrluKD3dxfdWCs+wXAAAAAElFTkSuQmCC"};
